const syllabusForClass = state => classId => state.byClass[classId] || null;

// The backend only returns a live syllabus (reading / setup / active / closed); an archived
// or failed one answers 404 and is stored as null, so "has one" is simply "not null".
const hasSyllabusForClass = state => classId => !!state.byClass[classId];

const isSyllabusLoaded = state => classId => !!state.loadedClasses[classId];

const uploadState = state => state.upload;

const checkAgainForClass = state => classId => !!state.checkAgain[classId];

const lessonRetriesFor = state => syllabusId => state.lessonRetries[syllabusId] || 0;

const lastErrorForClass = state => classId => (
  state.lastError && state.lastError.classId === classId ? state.lastError.code : null
);

export default {
  syllabusForClass,
  hasSyllabusForClass,
  isSyllabusLoaded,
  uploadState,
  checkAgainForClass,
  lastErrorForClass,
  lessonRetriesFor
};



// WEBPACK FOOTER //
// ./src/store/modules/syllabus/getters.js